"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var ZipCodeCountryHints = exports.ZipCodeCountryHints = {
	DigitsOnly: {
		DE: "Nur Zahlen, insgesamt {AMOUNT} Stellen.",
		EN: "Numbers only, {AMOUNT} digits total.",
		FR: "Chiffres seulement, {AMOUNT} chiffres au total."
	},
	Pattern: {
		DE: "Die PLZ sollte wie folgt aufgebaut sein:",
		EN: "Pattern must be of type:",
		FR: "Le motif doit être de type:"
	},
	ChosenCountry: {
		DE: "Die von eingegebene PLZ stimmt nicht mit dem geforderten Format für das ausgewählte Land überein.",
		EN: "The postcode you enter does not match the format required for the country you have selected.",
		FR: "Veuillez vérifier le code postal saisi, le format ne correspond pas au pays sélectionné."
	}
};